import {FeatureFlightChanged} from '../actions/featureflightActions'

const initialState ={flagvalue:false};

const featureflightReducer = (state=initialState,action:any)=>{

    switch(action.type){
        case FeatureFlightChanged: {
            return action.payload
        }
        default:{
            return state
        }
    }
}
export default featureflightReducer;